import { Button } from 'braid-design-system';
import type React from 'react';
import { useStores } from 'src/utils/hooks/useStores';
import { observer } from 'mobx-react';
import { useFilters } from './useFilters';
import { FilterClearButton } from './FilterClearButton';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

export interface StickyButtonsProps {
  onClose(): void;
}

export const StickyButtons: React.FC<StickyButtonsProps> = observer(
  ({ onClose }) => {
    const { t } = useTranslations(translations);
    const { jobApplicationStore, isMobile } = useStores();
    const { filtersStore, currentTotalOfJobApplications } = jobApplicationStore;
    const { resetFilters } = useFilters();

    return isMobile ? (
      <>
        <Button type="button" onClick={onClose}>
          {t('View candidateCount candidate/s', {
            candidateCount: currentTotalOfJobApplications,
          })}
        </Button>
        {filtersStore.hasSelectedFilter && (
          <Button
            type="button"
            variant="transparent"
            tone="neutral"
            onClick={() =>
              resetFilters({
                eventName: 'clear_filters_pressed',
                actionOrigin: 'candidate listing - filter section',
              })
            }
          >
            {t('Clear filters')}
          </Button>
        )}
      </>
    ) : (
      <>{filtersStore.hasSelectedFilter ? <FilterClearButton /> : null}</>
    );
  },
);
